/**
 * Menu Manager - Handles menu filtering based on API permissions
 */
export const MENU_DEFINITIONS = {
  // Authority Menus
  'inbox': {
    id: 'inbox',
    title: 'INBOX',
    description: 'View all notification updates',
    path: '/authority-dashboard',
    component: 'InboxView',
    icon: 'M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    roles: ['authority'],
    permissions: ['inbox'],
    requiresAuth: true
  },
  'assigned-complaints': {
    id: 'assigned-complaints',
    title: 'Assigned Complaints',
    description: 'Filter and edit complaints',
    path: '/authority-dashboard',
    component: 'AssignedComplaintsView',
    icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
    roles: ['authority'],
    permissions: ['assigned-complaints'],
    requiresAuth: true
  },
  'offline-complain': {
    id: 'offline-complaints',
    title: 'Offline Complaints',
    description: 'View and manage offline complaints',
    path: '/authority-dashboard',
    component: 'OfflineComplaintsView',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
    roles: ['authority'],
    permissions: ['offline-complain'],
    requiresAuth: true
  },
  'officers': {
    id: 'officers',
    title: 'Officers',
    description: 'Manage complaint officers and assignments',
    path: '/authority-dashboard',
    component: 'OfficersView',
    icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z',
    roles: ['authority'],
    permissions: ['officers'],
    requiresAuth: true
  },

  // CVO Menus
  'cvo-inbox': {
    id: 'cvo-inbox',
    title: 'INBOX',
    description: 'View all notification updates',
    path: '/cvo-dashboard',
    component: 'InboxView',
    icon: 'M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    roles: ['cvo'],
    permissions: ['inbox'],
    requiresAuth: true
  },
  'all-complaints': {
    id: 'all-complaints',
    title: 'All Complaints',
    description: 'View and manage all complaints',
    path: '/cvo-dashboard',
    component: 'ComplaintsView',
    icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
    roles: ['cvo'],
    permissions: ['all-complaints'],
    requiresAuth: true
  },
  'complaint-officers': {
    id: 'complaint-officers',
    title: 'Officers',
    description: 'Manage complaint officers and assignments',
    path: '/cvo-dashboard',
    component: 'OfficersView',
    icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z',
    roles: ['cvo'],
    permissions: ['complaint-officers'],
    requiresAuth: true
  },
  'settings': {
    id: 'settings',
    title: 'Settings',
    description: 'Manage dropdown options and system settings',
    path: '/cvo-dashboard',
    component: 'SettingsView',
    icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z',
    roles: ['cvo'],
    permissions: ['settings'],
    requiresAuth: true
  },

  // Officer Menus (for future use)
  'dashboard': {
    id: 'dashboard',
    title: 'Dashboard',
    description: 'View assigned complaints and tasks',
    path: '/officer-dashboard',
    component: 'OfficerDashboardView',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
    roles: ['officer'],
    permissions: ['dashboard'],
    requiresAuth: true
  },
  'my-cases': {
    id: 'my-cases',
    title: 'My Cases',
    description: 'Manage assigned cases',
    path: '/officer-dashboard',
    component: 'MyCasesView',
    icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
    roles: ['officer'],
    permissions: ['my-cases'],
    requiresAuth: true
  },
  'reports': {
    id: 'reports',
    title: 'Reports',
    description: 'Submit investigation reports',
    path: '/officer-dashboard',
    component: 'ReportsView',
    icon: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
    roles: ['officer'],
    permissions: ['reports'],
    requiresAuth: true
  }
};

export const getVisibleMenus = (userRole, userPermissions = [], userInfo = null) => {
  if (!userRole) {
    console.warn('getVisibleMenus: userRole is required');
    return [];
  }

  const allMenus = Object.values(MENU_DEFINITIONS);
  const roleMenus = allMenus.filter(menu => 
    menu.roles.includes(userRole.toLowerCase())
  );

  if (!Array.isArray(userPermissions) || userPermissions.length === 0) {
    return [];
  }

  const visibleMenus = roleMenus.filter(menu => {
    return menu.permissions.some(permission => 
      userPermissions.includes(permission)
    );
  });

  return addUserInfoToMenus(visibleMenus, userInfo);
};

export const getMenusFromAPI = (dashboardData) => {
  if (!dashboardData || !dashboardData.user || !dashboardData.user.role) {
    console.error('getMenusFromAPI: Invalid dashboard data');
    return [];
  }

  const userRole = dashboardData.user.role.name;
  const userPermissions = extractPermissionsFromAPI(dashboardData.assigned_menus);
  const userInfo = dashboardData.user;

  return getVisibleMenus(userRole, userPermissions, userInfo);
};

export const hasMenuAccess = (menuId, userRole, userPermissions = []) => {
  if (!menuId || !userRole) return false;

  const menu = MENU_DEFINITIONS[menuId];
  if (!menu) return false;

  if (!menu.roles.includes(userRole.toLowerCase())) {
    return false;
  }

  if (!Array.isArray(userPermissions) || userPermissions.length === 0) {
    return false;
  }

  return menu.permissions.some(permission => 
    userPermissions.includes(permission)
  );
};

export const getDefaultMenu = (userRole, userPermissions = []) => {
  const visibleMenus = getVisibleMenus(userRole, userPermissions);
  
  if (visibleMenus.length === 0) {
    return null;
  }

  const priorityOrder = ['inbox', 'cvo-inbox', 'dashboard', 'all-complaints', 'assigned'];
  
  for (const priorityId of priorityOrder) {
    const menu = visibleMenus.find(m => m.id === priorityId);
    if (menu) return menu;
  }

  return visibleMenus[0];
};

const extractPermissionsFromAPI = (assignedMenus) => {
  if (!Array.isArray(assignedMenus)) {
      return [];
    }

    return assignedMenus
    .map(menu => menu.route)
    .filter(Boolean);
};

const addUserInfoToMenus = (menus, userInfo) => {
  if (!userInfo) return menus;
  
  return menus.map(menu => ({
    ...menu,
    userInfo
  }));
};

export const getMenuById = (menuId) => {
  return MENU_DEFINITIONS[menuId] || null;
};

export const getMenuIdsForRole = (userRole) => {
  if (!userRole) return [];
  
  return Object.values(MENU_DEFINITIONS)
    .filter(menu => menu.roles.includes(userRole.toLowerCase()))
    .map(menu => menu.id);
};

export default {
  MENU_DEFINITIONS,
  getVisibleMenus,
  getMenusFromAPI,
  hasMenuAccess,
  getDefaultMenu,
  getMenuById,
  getMenuIdsForRole
};